/**
 * Business logic for transforming FinalJob to DisplayJob
 */

import type { DisplayJob } from '../../../../types';
import type { FinalJob } from '../../../../lambda/types';

/**
 * Transforms a FinalJob to DisplayJob for a given locale
 * Extracts language-specific fields and removes language suffixes
 * 
 * @param job - The FinalJob object to transform
 * @param lang - The target language code ('en', 'fi', or 'sv')
 * @returns A DisplayJob object with language-specific fields extracted
 */
export function transformJobForLanguage(job: FinalJob, lang: string): DisplayJob {
  const jobObj = job as Record<string, unknown>;
  const result: Record<string, unknown> = {};
  const langSuffix = `_${lang}`;
  
  for (const key in jobObj) {
    if (key.endsWith(langSuffix)) {
      const baseKey = key.slice(0, -langSuffix.length);
      result[baseKey] = jobObj[key];
    } else if (!key.match(/_en$|_sv$|_fi$/)) {
      result[key] = jobObj[key];
    }
  }
  
  if (result.objectID) {
    result.objectID = `${result.objectID}`;
  }
  
  return result as DisplayJob;
}

